// scoreUtils.js
export const getScoreColor = (score) => {
    if (score <= 65) {
        return {
            main: '#ef4444',
            gradient: ['#ef4444', '#f97316'] // red to orange
        };
    }
    if (score <= 80) {
        return {
            main: '#eab308',
            gradient: ['#f97316', '#84cc16'] // orange to lime-green
        };
    }
    return {
        main: '#22c55e',
        gradient: ['#84cc16', '#22c55e'] // lime-green to green
    };
};

export const calculateMetricValue = (records, metricConfig) => {
    if (!records || records.length === 0) return 0;

    const { calculation } = metricConfig;
    if (!calculation) return 0;

    const { type, fields, condition } = calculation;

    // Filter records if condition is specified
    const filteredRecords = condition
        ? records.filter(record => evaluateCondition(condition, record))
        : records;

    console.log(`Calculating metric for ${metricConfig.id}:`, {
        type,
        fields,
        condition,
        recordCount: records.length,
        filteredCount: filteredRecords.length
    });

    switch (type) {
        case 'average': {
            if (!fields || fields.length === 0) {
                // If no fields specified but we have a single field in the config
                if (calculation.field) {
                    const sum = filteredRecords.reduce((acc, record) =>
                        acc + (Number(record[calculation.field]) || 0), 0);
                    return filteredRecords.length > 0 ? sum / filteredRecords.length : 0;
                }
                return 0;
            }

            const sum = filteredRecords.reduce((acc, record) => {
                const fieldValues = fields.map(field => Number(record[field]) || 0);
                const avgValue = fieldValues.reduce((a, b) => a + b, 0) / fields.length;
                return acc + avgValue;
            }, 0);

            return filteredRecords.length > 0 ? sum / filteredRecords.length : 0;
        }

        case 'percentage': {
            if (filteredRecords.length === 0) return 0;
            return (filteredRecords.length / records.length) * 100;
        }

        case 'count': {
            const result = filteredRecords.length;
            //console.log('Count result:', result);
            return result;
        }

        default:
            return 0;
    }
};

export const evaluateCondition = (condition, record) => {
    try {
        return new Function('record', `return ${condition}`)(record);
    } catch (error) {
        console.error('Error evaluating condition:', error);
        return false;
    }
};

export const formatMetricValue = (value, metricConfig) => {
    if (typeof value !== 'number') return '0';

    const { calculation } = metricConfig;

    switch (calculation?.type) {
        case 'percentage':
            return `${value.toFixed(1)}%`;
        case 'count':
            return Math.round(value).toString();
        default:
            return value.toFixed(1);
    }
};
